import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled, { useTheme } from 'styled-components';

import TrashIcon from 'packages/kakapo-ui-kit/assets/icons/TrashIcon';

import { ParagraphSmall } from './Paragraph';
import Spinner from './Spinner';

type Variables = { input: { id: string } };
type Mutation = (options: { variables: Variables }) => [() => Promise<any>, { loading: boolean }];

const Button = styled(Flex)`
	cursor: pointer;
`;

export default function ArchiveButton<T extends { id: string; isArchived: boolean }>(props: {
	item: T;
	useArchive: Mutation;
	useRestore: Mutation;
}) {
	const theme = useTheme() as any;

	const options = { variables: { input: { id: props.item.id } } };
	const [archive, { loading: archiveLoading }] = props.useArchive(options);
	const [restore, { loading: restoreLoading }] = props.useRestore(options);

	const { t } = useTranslation();

	const toggleArchived = async () => {
		if (props.item.isArchived) {
			await restore();
		} else {
			await archive();
		}
	};

	if (archiveLoading || restoreLoading) {
		return (
			<Box>
				<Spinner isLoading size="18px" verticalMargin={0} />
			</Box>
		);
	}

	return (
		<Button alignItems="center" justifyContent="center" onClick={toggleArchived}>
			<ParagraphSmall color="slateBlue">
				{t(`goals.button.${!props.item.isArchived ? 'archive' : 'restore'}`)}
			</ParagraphSmall>
			<Box ml={2}>
				<TrashIcon color={theme.colors.slateBlue} />
			</Box>
		</Button>
	);
}
